import { IBasePickerSuggestionsProps, Icon, Stack, useTheme } from '@fluentui/react';
import { IAutocompletePickerOption } from '../../data-types/autocomplete/IAutocompletePickerOption';

export interface ISuggestedAutocompleteItemProps extends IBasePickerSuggestionsProps {
    item: IAutocompletePickerOption;
}

export const SuggestedAutocompleteItem = (props: ISuggestedAutocompleteItemProps) => {
    const theme = useTheme();
    const color = theme.palette.themeLighterAlt;
    return (
        <Stack horizontal horizontalAlign="space-between" style={{ width: '100%' }}>
            <Stack.Item style={{ padding: 5, textAlign: 'start' }}>{props.item.label}</Stack.Item>
            {props.item.isGroup && (
                <Stack.Item
                    style={{
                        borderRadius: '16px',
                        fontSize: '10px',
                        backgroundColor: color,
                        display: 'flex',
                        margin: 5,
                        padding: 5,
                        textAlign: 'center',
                        alignSelf: 'center',
                        maxHeight: 20,
                        minWidth: 50,
                    }}
                >
                    <Icon iconName="EngineeringGroup" style={{ fontSize: '12px', paddingRight: 5 }} />
                    <span>Group</span>
                </Stack.Item>
            )}
        </Stack>
    );
};
